module.exports = __webpack_public_path__ + "media/images/emblems/Cuarny-coat_of_arms-7248cf164990e3cb487f80f1a0d88b7c.svg";